import { FormControl, styled } from '@mui/material';

const FormControlWithMargin = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
}));

export default FormControlWithMargin;
